module.exports = __webpack_public_path__ + "43315d97.png";